// extracted by mini-css-extract-plugin
export default {"mainContent":"Inicio_mainContent__CrvAZ","contato":"Inicio_contato__o76O0","Ofertas":"Inicio_Ofertas__YouaJ","AppExclusivo":"Inicio_AppExclusivo__Ro3+8"};